<div class="container locker-date">

  @if (loading==1) {
    <div>
      <div class="row">
        <div class="col">
          <div class="mb-3">
            <h1>{{'visor.generate.reserve'|traduccion}}</h1>
          </div>
        </div>
      </div>
    </div>
  }

  @if (loading==2) {
    <div>
      <div class="row">
        <div class="col">
          <div class="mb-3">
            <h3>{{'visor.title'|traduccion}} {{resumePayment.userData?.name}}</h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col resumen-reserve">
          <div class="card">
            <div class="card-body">
              <div class="card-text">
                <div>
                  <div class="resumen-location">
                    <p>{{'visor.label.kioskAddress'|traduccion}} {{resumePayment.kioskAddress}}</p>
                  </div>
                  <!--
                  <div class="resumen-date">
                    <p>{{'visor.from'|traduccion}} {{ infoCart.startDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es' }}</p>
                    <p>{{'visor.to'|traduccion}} {{ infoCart.endDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es' }}</p>
                  </div>
                  -->
                  <div class="resumen-locker">
                    <p>{{'visor.label.totalReserved'|traduccion}} {{ resumePayment.items.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="card-text">
                <div class="tracks">
                  <div class="row">
                    <div class="col"><div><p>{{'visor.resume.track'|traduccion}}</p></div></div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{'visor.from'|traduccion}}</div>
                    <div class="col-6">{{'visor.to'|traduccion}}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{resumePayment.startDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</div>
                    <div class="col-6">{{resumePayment.endDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (!canceled) {
            <div class="c-resumen">
              <div class="">
                <div class="container card">
                  @for (item of resumePayment.items; track item) {
                    <div class="order mt-4 border-bottom">
                      <div class="row">
                        <div class="col">
                          <p class="font-weight-bold">{{'visor.resume.nLocker'|traduccion}} {{item.nLocker}}</p>
                          <p>{{'visor.resumen.typeLocker'|traduccion}}: {{item.categoryCode|traduccion:'name'}}</p>
                        </div>
                        <div class="col">
                          <!-- item.totalPriceToPay -->
                          @if (!subscription && item.unpaid) {
                            <div>
                              <button class="btn btn-primary btn-round" (click)="goToPay(item)">
                                {{'visor.bt.toPay'|traduccion}}
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="dropdown-divider"></div>
                      <div class="row paid">
                        <div class="col-4">{{'visor.price'|traduccion}}</div>
                        <div class="col-4 offset-4">{{item.unitPrice}}€ / {{item.period}} {{item.unit|traduccion}}</div>
                      </div>
                      <div class="dropdown-divider"></div>
                      <div class="row">
                        <div class="col-4">{{'visor.subtotal'|traduccion}}</div>
                        <div class="col-4 offset-4">{{item.totalPrice}} €</div>
                      </div>
                    </div>
                  }
                  <div class="mt-4"></div>
                  <div class="dropdown-divider"></div>
                  <div class="row">
                    <div class="col-4">
                      <p class="font-weight-bold">{{'visor.total'|traduccion}}</p>
                    </div>
                    <div class="col-4 offset-4">
                      <p class="total font-weight-bold">{{resumePayment.total}}€</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div> <!-- /resumen-reserve -->
      </div>
      <div class="row">
        <div class="col">
          @if (active && !resumePayment.unpaid) {
            <div class="mt-4">
              <p class="mb-2 font-weight-bold">{{ 'visor.resume.noticeSendEmail'|traduccion }}{{ resumePayment.userData.email }}</p>
              <p class="font-italic">{{ 'visor.resume.noticeResendEmail'|traduccion }}
                <button class="btn btn-primary btn-round" (click)="resendEmail()" [disabled]="waitingTime!=null">
                  {{ 'visor.bt.resendEmail'|traduccion }}
                </button>
              </p>
              @if (waitingTime) {
                <p class="font-italic text-danger">{{ waitingTime }}</p>
              }
            </div>
          }
          @if (cancelable) {
            <div>
              <button class="btn btn-primary btn-round" [disabled]="!cancelable" (click)="cancelCheckoutCard()">
                {{subscription ? ('visor.bt.subscription.cancel'|traduccion) : ('visor.bt.cancel'|traduccion)}}
              </button>
              @if (!subscription && cancelable) {
                <p>{{'visor.resume.cancelAllow'|traduccion}}</p>
              }
              @if (!subscription && !cancelable) {
                <p>{{'visor.resume.cancelNotAllow'|traduccion}}</p>
              }
              @if (subscription && cancelable) {
                <p>{{'visor.resume.cancelAllow'|traduccion}}</p>
              }
            </div>
          }
          @if (!subscription && canceled) {
            <div class="text-danger">
              <h5>{{'visor.resume.reserveCancelled'|traduccion}}</h5>
            </div>
          }
          @if (subscription && canceled) {
            <div class="text-danger">
              <h5>{{'visor.resume.subscriptionCancelled'|traduccion}}</h5>
            </div>
          }
          @if (closed && !canceled) {
            <div class="text-danger">
              <h5>{{'visor.resume.reserveClosed'|traduccion}}</h5>
            </div>
          }
        </div>
      </div>
    </div>
  }

</div>